const state = {
  specialHeader: false,
  bigstCount: 0,
  isLoginPage: false,
  isdownload:false
}

const mutations = {
  isSpecialHeader(state, status) {
    state.specialHeader = status
  },
  getBigstCount(state, status) {
    state.bigstCount = status
  },
  getLoginPage(state, status) {
    state.isLoginPage = status
  },
  getdownload(state, status) {
    state.isdownload = status
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/header.js